module.exports = __webpack_public_path__ + "img/order.7e4cf436.png";